<template>
  <v-text-field
    v-if="editable"
    v-bind="$attrs"
    v-model="inputValue"
    :placeholder="placeHolder"
    :rules="rules"
    :counter="maxlength"
    color="tertiary"
    dense
    filled
  />
  <div class="readonly mb-7" v-else>
    <div class="label body-2 tertiary--text">{{ $attrs.label }}</div>
    <p class="value secondary--text">{{ inputValue }}</p>
  </div>
</template>

<script>
export default {
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    rules: {
      type: Object,
      required: false
    },
    maxlength: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      rules: [
        v =>
          !!v ||
          i18n.t('portal.general.user_settings.user_profile.rules.required'),
      ],
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(inputValue) {
        this.$emit('input', inputValue)
      }
    },
    placeholder() {
      return this.$attrs.placeholder ? this.$attrs.placeholder : ' '
    }
  }
}
</script>

<style></style>
